import useModalContext from "@contexts/modalContext"
import HlsPlayer from "@elements/HlsPlayer"
import ModalContainer from "@elements/ModalContainer"
import React, { useLayoutEffect, useRef, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"

// TODO: Honestly, we can write the contents in the exact same file for ease of use.
//       There's just no point in making a separate component somewhere else when they're obviously dependent

const MediaViewer = ({ mediaViewer }) => {
  // const { mediaViewer } = useModalContext()
  const location = useLocation()
  const [image, setImage] = useState(null)
  const [video, setVideo] = useState(null)
  const imageState = location?.state?.image
  const videoState = location?.state?.video
  // console.log(mediaViewer.isOpen)
  // Sets image on initial render, either through session storage, or through location state
  // NOTE: If we don't set the image to state at all, the data leaves before the exit animation,
  //       and the rendering on exit can get pretty weird.
  useLayoutEffect(() => {
    if (imageState && !image) {
      setImage(imageState)
    }
    return () => {
      setImage(null)
    }
  }, [imageState])

  useLayoutEffect(() => {
    if (videoState && !video) {
      setVideo(videoState)
    }
    return () => {
      setVideo(null)
    }
  }, [videoState])

  return(
    <ModalContainer
      // animationClassNames='animation__modal-scale'
      open={mediaViewer.isOpen}>
      {/* TODO: We can use this pattern to prevent excessive rendering of content, and use a settimeout to only remove the content on exit */}
      {/* NOTE: It's not a huge deal that the component is rerending so much as its a big deal that all the logic in the modal is being called again
                so if we separate the contents from the container modal and render them conditionally, we'll get a decent, albeit annoying workaround */}
      {/* {mediaViewer.isOpen && */}
        <div style={{ height: '100dvh', width: '100dvw', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {image &&
            <img src={image?.url} style={{ maxHeight: '100dvh', maxWidth: '100dvw' }}/>
          }
          {video &&
            <HlsPlayer video={video} autoPlay />
          }
          {/* {console.log('rendering contents')} */}
        </div>
      {/* } */}
    </ModalContainer>
  )
}

export default React.memo(MediaViewer)
